import { useContext } from 'react';

import { AdminBillingContext } from './AdminBillingContext';

export const useAdminBillingContext = () => {
  const context = useContext(AdminBillingContext);
  if (!context) {
    throw new Error('useAdminBillingContext must be used within an AdminBillingProvider');
  }
  return context;
};
